module.exports = __webpack_public_path__ + "img/cbc5a6c.png";